import { Injectable, TemplateRef } from '@angular/core';

import { NzNotificationDataOptions, NzNotificationService } from 'ng-zorro-antd/notification';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public templateRef: TemplateRef<any>;

  constructor(
    private notification: NzNotificationService,
  ) { }

  public showTemplate(options: NzNotificationDataOptions): void {
    if (this.templateRef) {
      this.notification.template(this.templateRef, { ...options });
    }
  }

  public setTemplate(template: any) {
    this.templateRef = template;
  }
}
